export enum PaymentStatusEnum {
    PAID = "PAID",
    SCHEDULED = "SCHEDULED",
    UNPAID = "UNPAID",
    CANCELLED = "CANCELLED",
    NONE = "NONE",
    OTHER = "OTHER",
}